import { render, staticRenderFns } from "./DispatchMap.vue?vue&type=template&id=6f83699e&scoped=true"
import script from "./DispatchMap.vue?vue&type=script&lang=js"
export * from "./DispatchMap.vue?vue&type=script&lang=js"
import style0 from "./DispatchMap.vue?vue&type=style&index=0&id=6f83699e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83699e",
  null
  
)

export default component.exports